'use client';

import type { ComponentType, ReactElement } from 'react';
import { UserMenuInitialTab } from '@/contexts/layout';
import { ModalLocation } from '@/constants/componentPresets';
import { ColorType } from '@/theme/colors';
import { Cmodal } from '../Cmodal';
import type { CusermenuProps } from '../Cusermenu';
import { UserMenuModalContent } from './UserMenuModalContent';

interface UserMenuModalProps {
  UserMenuComponent: ComponentType<CusermenuProps>;
  isUserMenuModalOpen: boolean;
  onUserMenuModalClose: () => void;
  requestUserMenuClose: () => boolean | void;
  onUserMenuUnsavedChangesChange: (hasUnsavedChanges: boolean) => void;
  userMenuInitialTab: UserMenuInitialTab;
}

export function UserMenuModal({
  UserMenuComponent,
  isUserMenuModalOpen,
  onUserMenuModalClose,
  requestUserMenuClose,
  onUserMenuUnsavedChangesChange,
  userMenuInitialTab,
}: UserMenuModalProps): ReactElement {
  return (
    <Cmodal
      dataElScope="Cpagelayout/UserMenuModal"
      visible={isUserMenuModalOpen}
      location={ModalLocation.Right}
      background={ColorType.Black}
      backgroundOpacity={0.45}
      content={
        <UserMenuModalContent
          UserMenuComponent={UserMenuComponent}
          initialTab={userMenuInitialTab}
          onClose={onUserMenuModalClose}
          onUnsavedChangesChange={onUserMenuUnsavedChangesChange}
        />
      }
      menuTitle="User Menu"
      onClose={requestUserMenuClose}
    />
  );
}
